import { Link } from "react-router-dom";
import PageShell from "../components/common/PageShell";
import { useAuth } from "../context/AuthContext";
import { inr, walletTotal } from "../utils/format";

export default function Home() {
  const { user, wallet } = useAuth();
  const w = wallet || {};
  return (
    <PageShell title={`Hi, ${user?.username || "Player"}`} back={false}>
      <section className="pg-card pg-balance-card">
        <span className="pg-muted">Total balance</span>
        <div className="pg-balance">{inr(walletTotal(w))}</div>
        <div className="pg-actions">
          <Link className="pg-btn" to="/game">
            Play Chicken Road
          </Link>
          <Link className="pg-btn ghost" to="/deposit">
            Add money
          </Link>
        </div>
      </section>
      <section className="pg-wallet">
        <div className="pg-card">
          <span className="pg-muted">Deposit</span>
          <div className="pg-big">{inr(w.depositBalance)}</div>
        </div>
        <div className="pg-card">
          <span className="pg-muted">Winnings</span>
          <div className="pg-big pg-win">{inr(w.winningBalance)}</div>
        </div>
      </section>
    </PageShell>
  );
}
